import { Header } from "@/components/Header";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="min-h-screen pattern-bg flex flex-col">
      <main className="container py-8 flex-grow">
        <Header />
        {children}
      </main>
      <footer className="py-4 text-center text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
        Made With{" "}
        <span className="text-red-500 animate-pulse inline-block transform hover:scale-110 transition-transform duration-300">
          ♥️
        </span>{" "}
        by{" "}
        <a
          href="https://twitter.com/BoDresha"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold hover:underline"
        >
          Bodresha
        </a>
      </footer>
    </div>
  );
};